import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { useApp } from '../context';
import { RotateCcw } from 'lucide-react';

export function UndoToast() {
  const { state, restoreContact, commitDeleteContact } = useApp();
  const deletedContactId = state.pendingDeleteContactId;
  const deletedContactName = state.pendingDeleteContactName;
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (!deletedContactId) {
      setProgress(100);
      return;
    }

    const duration = 10000; // 10 seconds
    const intervalTime = 50; // Update every 50ms smooth
    const totalSteps = duration / intervalTime;
    let currentStep = 0;

    const interval = setInterval(() => {
      currentStep++;
      setProgress(Math.max(0, 100 - (currentStep / totalSteps) * 100));

      if (currentStep >= totalSteps) {
        clearInterval(interval);
        commitDeleteContact(deletedContactId);
      }
    }, intervalTime);

    return () => clearInterval(interval);
  }, [deletedContactId, commitDeleteContact]);

  return (
    <AnimatePresence>
      {deletedContactId && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          className="fixed bottom-24 left-4 right-4 z-50 overflow-hidden rounded-2xl bg-slate-800 text-white shadow-2xl"
        >
          <div className="flex items-center justify-between p-4">
            <p className="text-sm font-medium">
              <span className="font-bold text-white">{deletedContactName}</span> removed
            </p>
            <button
              onClick={() => restoreContact(deletedContactId)}
              className="flex items-center gap-2 rounded-xl bg-white/10 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-white/20 active:scale-95"
            >
              <RotateCcw size={16} />
              Undo
            </button>
          </div>
          {/* Progress bar */}
          <div className="h-1 w-full bg-slate-700">
            <motion.div
              className="h-full bg-[#fa8585]"
              style={{ width: `${progress}%` }}
              transition={{ duration: 0 }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
